<template>
  <div class="cart-index">
    <Loading v-if="!isRequest" />
    <NavUser @evtLogout="evtLogout" />

    <Summary v-if="isSubmit" 
      :confirm="confirmOrder"
      :cancel="cancelOrder"
      :store="this.store"
      :order="this.order"
      :serviceType="this.deliveryOption" />
    
    <!-- 顶部导航信息 -->
    <TopNavbar :title="'Order Summary'" :bgColor="'bg-red'" :class="isSubmit? 'hideVisibility':'showVisibility'" />
    <div v-if="isRequest" class="main" :class="isSubmit? 'hideVisibility':'showVisibility'">
      <div class="order-store-name flex flex-center">
        <div class="store-logo"><img :src="store.logo" /></div>
        <div class="store-name">{{ store.title }}</div>
      </div>
      <!-- 桌子信息 -->
      <TablesInfo :tablesInfo="table" />
      <div class="product-list">
        <div class="list-header bg-red flex flex-start justify-between">
          <div class="item-name"></div>
          <div class="item-qty">Qty.</div>
          <div class="item-price">Price</div>
        </div>
        <!-- 已选择的商品列表 -->
        <div class="list-items flex flex-start justify-between flex1" v-for="(item, index) in goodsList" :key="index" :class="{'line-top':index}">
          <div class="item-image">
            <img :src="item.detail.thumb" />
          </div>
          <div class="item-name">
            <div class="w600">{{item.name || item.detail.title}}</div>
            <div>
              <span v-for="(optName, optIndex) in item.options" :key="optIndex">
                <Tags v-for="(vname, vkey) in optName" :key="vkey" :text="vname" />
              </span>
            </div>
          </div>
          <div class="item-qty">{{item.qty}}</div>
          <div v-if="parseInt(item.isspecial) == 2" class="item-price">RMxx {{ item.optionname }}</div>
          <div v-if="parseInt(item.isspecial) != 2" class="item-price">RM {{ fmPrice(parseFloat(item.price)*parseInt(item.qty)) }}</div>
        </div>
      </div>
      <div class="custom-form">
        <!--
        <div class="padd5px">
          <div class="flex justify-between padd5px user-nav-name">
            <div class="user-nav-name-label">Membership ID</div>
            <input ref="membership_id" class="user-nav-name-value inputfocus" v-model="membership_id" placeholder="Your membership ID" />
          </div>
        </div>
        -->

        <!-- 优惠券单元格 -->
        <van-cell :title="'Coupons'" is-link :value="coupon_code || '0 coupons available'" @click="popupCoupon = coupon_list.length" />
        <van-popup v-model="popupCoupon" position="bottom" :style="{ height: '20%' }">
          <div class="flex justify-between padd5px">
            <van-button type="danger" size="mini" @click="cleanCoupon">Clean</van-button>
            <van-button type="info" size="mini" @click="applyCoupon">Okey</van-button>
          </div>
          <van-radio-group v-model="coupon_code">
            <van-cell-group>
              <van-cell v-for="itemCoupon in coupon_list" :key="itemCoupon" :title="itemCoupon.title" clickable @click="coupon_code = itemCoupon.name">
                <van-radio slot="right-icon" :name="itemCoupon.name" />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </van-popup>
        <!-- 客户的包裹收货地址 -->
        <van-cell-group>
          <div class="padd5px">
            <div class="flex flex-center justify-between padd5px user-nav-name">
              <div class="user-nav-name-label">Address * </div>
              <div class="flex flex-center justify-between flex1" @click="userAddressList">
                <div class="flex1 select-address">
                  <div v-if="!delivery_current_address || delivery_current_address.address_id == undefined">Select Address</div>
                  <div v-if="delivery_current_address && delivery_current_address.address_id != undefined">
                    <div class="delivery-address">{{delivery_current_address.name}}</div>
                  </div>
                </div>
                <van-icon name="arrow" />
              </div>
            </div>
          </div>
        </van-cell-group>
        <van-cell-group v-if="visiable_email">
          <div class="padd5px">
            <div class="flex justify-between padd5px user-nav-name">
              <div class="user-nav-name-label">Email *</div>
              <input ref="email" class="user-nav-name-value inputfocus" v-model="email" placeholder="abc@example.com" />
            </div>
          </div>
        </van-cell-group>

        <!-- 新增日期和时间选择 -->
        <div class="padd10px"  v-if="isSchedule">
        <div class="flex justify-between padd5px">
          <van-checkbox class="checkbox-mobile-label" icon-size="15px" v-model="order.schedule.type" shape="square" @click="isScheduleEnabled()"><span style="font-weight: bolder">[PRE-ORDER]</span> Driver Pick Up Time 司机取餐时间</van-checkbox>
          <input v-if="order.schedule.type" style="border: none; text-align: right;font-size: 14px" class="user-nav-name-value inputfocus"  v-model="dish_datetime" placeholder="Click and select datetime" readonly @click="showScheduleDateTimePicker" />
          <input v-if="!order.schedule.type" style="border: none; text-align: right;font-size: 14px; background-color: #e3e3e3;" class="user-nav-name-value inputfocus"  v-model="dish_datetime" placeholder="Click and select datetime" readonly />
          <van-popup v-model="showDishDatetime" position="bottom">
            <DateTimePicker 
              :confirm="confirmFn"
              :cancel="cancelFn"
              :minDate="this.minDate"
              :date="this.order.schedule.datetime" />
          </van-popup>
        </div>
        </div>
        <van-cell-group>
          <van-field v-if="!store.isEpointEnabled" v-model="order.remark" rows="5" autosize type="textarea" placeholder="Order's Remark"/>
          <van-field v-if="store.isEpointEnabled" v-model="order.remark" rows="5" autosize type="textarea" placeholder="Order's Remark  (max 19 characters)" maxlength="19"/>
        </van-cell-group>
        <div style="padding:8px 8px 18px 8px;">
          <van-checkbox class="checkbox-mobile-label" icon-size="12px" v-model="isTermsAccepted" shape="square">
            By placing this order, I agree to the FastOrder.my
            <span class="linkcolor" @click="funTC('https://business.fastorder.my/terms-conditions/')">Terms & Condition</span> and
            <span class="linkcolor" @click="funTC('https://business.fastorder.my/privacy-policy/' )">Privacy Policy</span>
          </van-checkbox>
        </div>

      </div>
    </div>
    <div v-if="isRequest" class="footer bg-red" :class="isSubmit? 'hideVisibility':'showVisibility'">
      <div class="summary">
        <div class="row" v-for="(item, index) in cart.summmary" :key="index">
          <div class="flex justify-end">
            <div class="label">{{item.label}}
              <span v-if="item.type=='promo' && isCoupon">({{coupon_code}})</span>
            </div>
            <div class="colons">:</div>
            <div class="currency">RM</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="flex flex-center justify-between place-order">
        <div class="rm-price">RM {{ cartTotal }}</div>
        <div class="btn-order" @click="placeorder">
          <div>Confirm</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { h } from 'vue';
import TopNavbar from '../../components/common/TopNavbar.vue'
import NavUser from '../../components/common/NavUser.vue'
import TablesInfo from '../../components/common/TablesInfo.vue'
import Loading from '../../components/common/Loading.vue'
import Tags from '../../components/common/Tags.vue'
import DateTimePicker from '../../components/common/DateTimePicker.vue'
import Summary from '../../components/common/Summary.vue'
import { Toast } from 'vant';
import { isNumber } from 'util'
import { cartPage, addToOrder, checkHistoryExist, getDeliveryQuotation, validateBusinessAndHoliday } from '@/api/api'
import mockDemo from '@/api/mock'
import { cartMixin } from '@/mixins/cartMixin'
import { mapGetters, mapActions } from 'vuex'
import { parse } from 'querystring'
import moment from 'moment'

export default {
  components: {
    TopNavbar, TablesInfo, Tags, Loading, NavUser, DateTimePicker, Summary
  },
  props: {},
  data() {
    return {
      isRequest: false,
      isTermsAccepted: true,
      goodsList: [],
      cartTotal: 0.00,
      cart: {
        summmary: []
      },
      isCoupon: false,
      popupCoupon: false,
      coupon_code: '',
      coupon_list: [],
      membership_id: '',
      receiver_name: '',
      receiver_phone: '',
      email: '',
      receiver_addr1: '',
      receiver_addr2: '',
      receiver_addr3: '',
      isTakeaway: false,
      isDelivery: false,
      isSchedule: false,
      isLogin: false,
      ssouser: false, //sso.user 信息
      dish_datetime: '',
      showDishDatetime: false,
      sso: {},
      lalamove: {},
      lalamove_service_type: '', // 配送外卖时的交通类型, 页面中暂时没有用到
      isQuotation: false, //判断是否已经报价
      minDate: '',
      maxDate: '',
      isSubmit: false,
      datetimePicker: {
        title: 'Schedule Date & Time',
        confirmText: 'Confirm',
        cancelText: 'Cancel'
      },
      store: {
        id: 0,
        title: '',
        logo: '',
        location: {
          address: '',
          lat: 0,
          lng: 0
        },
        is_rest: 0,
        is_show: 0,
        readyInMinute: 0,
        isEmailRequired: false,
        isEpointEnabled: false,
      },
      businessHours: {},
      holiday: {},
      storeInfo: {},
      scheduleType: false,
      deliveryOption: {},
      table: {},
      order: {
        isDineIn: false,
        isTakeaway: false,
        isDelivery: true,
        etaInMinute: 0,
        user: {
          name: '',
          contact: '',
          email: '',
        },
        address: {
          name: '',
          address1: '',
          address2: '',
          address3: '',
          city: '',
          state: '',
          country: '',
          zip: '',
          lat: '',
          lng: ''
        },
        schedule: {
          type: false,
          datetime: new Date()
        },
        remark: ''
      }
    }
  },
  created() {
    this.resolveDateTime();
    this.get_data();
    if (this.delivery_current_address && this.delivery_current_address.address_id != undefined) {
      this.receiver_name = this.delivery_current_address.nickname
      this.receiver_phone = this.delivery_current_address.mobile
    }
    if (this.teleport_list && this.teleport_list.length != 0){
        this.deliveryOption = this.teleport_list
    }
    if (this.delyva_list && this.delyva_list.length != 0){
        this.deliveryOption = this.delyva_list
    }
  },
  mixins: [cartMixin],
  computed: {
    ...mapGetters(["delivery_current_address", "delivery_current_storeinfo", "user_islogin", "user_detail","teleport_list","delyva_list"]),
  },
  methods: {
    ...mapActions({
      saveCurrentStoreInfo: "delivery/settingCurrentStoreInfo",
      saveCurrentAddress: "delivery/settingCurrentAddress",
    }),
    showScheduleDateTimePicker() {
      this.showDishDatetime = !this.showDishDatetime;
    },
    isScheduleEnabled() {
      this.order.schedule.type != this.order.schedule.type;

      if(this.order.schedule.type) {
        this.setMinDate();
        this.setMaxDate();
        this.order.schedule.datetime = this.minDate;
      } else {
        this.order.schedule.datetime = new Date();
      }

      this.resolveDateTime();
      this.quotation();
    },
    setMinDate() {
      let currDT = (new Date()).getTime();
      let minDate = new Date(currDT + (31 * 60 * 1000));

      if(minDate.getMinutes()%10 > 0) {
        minDate.setMinutes(minDate.getMinutes() + (10-(minDate.getMinutes()%10)));
      }
      this.minDate = minDate
      this.checkBusinessHour(this.minDate)
    },
    checkBusinessHour(mindate){
      let minDate = new Date(mindate);
      console.log('minDate from checkBusinessHour', minDate)

      if(minDate.getMinutes()%10 > 0) {
        minDate.setMinutes(minDate.getMinutes() + (10-(minDate.getMinutes()%10)));
      }
      let businesshours = this.businessHours.data
      //let mindate = new Date(minDate)
      let daysArrayOpen = new Array()
        for (let i in businesshours){
            let daysInArray = Object.keys(businesshours[i])
            console.log('Business hours', businesshours[i])
            console.log('minDate day include in database',daysInArray.toString())
            daysArrayOpen.push(daysInArray.toString())
        }
        for (let i in businesshours){
          for (let j in businesshours[i]){
            businesshours[i][j].sort((a,b) => Number(a.start) - Number(b.start));
            let daysInNumber = this.getDaysNumber(j)
            let maxDataToday = businesshours[i][j].length - 1
            let days = new Array
            for(let i=0;i<7;i++){
              days[i] = this.getDays(minDate.getDay())
              let daysValidate = daysArrayOpen.includes(days[i])
              console.log('daysValidation open',daysValidate) 
              if (!daysValidate){
                minDate.setDate(minDate.getDate() + 1)
                minDate.setHours(0)
                minDate.setMinutes(0)
              } else {
                break;
              }
            }
            if (minDate.getDay() == daysInNumber){
              console.log('mindate details', minDate + 'And daysInNumber ' , daysInNumber)
              let timeTodayLength = businesshours[i][j].length
              for (let k in businesshours[i][j]){
                console.log('k value ',k + ' and length of data for today ', businesshours[i][j].length)
                let hourStartString = businesshours[i][j][k]['start'].toString().padStart(4,"0")
                let hourEndString = businesshours[i][j][k]['end'].toString().padStart(4,"0")
                let hourStart = Number(hourStartString.substring(0,2))
                let hourEnd = Number(hourEndString.substring(0,2))
                console.log('Hour start for the day ', hourStartString + ' Hour end for the day ', hourEndString)
                if (minDate.getHours() > hourStart && minDate.getHours() < hourEnd){
                  console.log('If in between hourStart & hourEnd >>> '+' minDate details ', minDate + ' hourEnding', hourEndString)
                  this.minDate = minDate
                  this.order.schedule.datetime = this.minDate
                  break;
                } else if (minDate.getHours() == hourStart){
                    if (minDate.getMinutes() >= Number(hourStartString.substring(2,4))){
                      console.log('Min Date is in operation hour', minDate)
                      this.minDate = minDate
                      this.order.schedule.datetime = this.minDate
                      break;
                    } else {
                      console.log('Minute for hour start', minDate.getMinutes())
                      console.log('Min date is out operation hour in minutes', minDate + ' hourStart = ', hourStartString + ' hourEnd = ' , hourEndString)
                      minDate.setDate(minDate.getDate())
                      minDate.setMinutes(Number(hourStartString.substring(2,4)))
                      this.minDate = minDate
                      this.order.schedule.datetime = this.minDate
                      break;
                    }
                } else if(minDate.getHours() == hourEnd){
                    if (minDate.getMinutes() <= Number(hourEndString.substring(2,4))){
                      this.minDate = minDate
                      this.order.schedule.datetime = this.minDate
                      break;
                    } else {
                      if (k == maxDataToday){
                        minDate.setDate(minDate.getDate() + 1)
                        minDate.setHours(0)
                        minDate.setMinutes(0)
                        console.log('End of the day for business hours', k)
                        break;
                      } else {
                        continue;
                      }
                    }
                } else if (minDate.getHours() > hourEnd){
                  console.log('If more than hourEnd >>> '+' minDate details ', minDate + ' hourEnding', hourEndString)
                  console.log('value of k ', k + ' value of maxDataToday ', maxDataToday)
                    if (k == maxDataToday){
                      minDate.setDate(minDate.getDate() + 1)
                      minDate.setHours(0)
                      minDate.setMinutes(0)
                      console.log('End of the day for business hours', k)
                      break;
                    } else {
                      continue;
                    }
                } else {
                    if(timeTodayLength == 1){
                    console.log('If less than hourStart or the same >>> '+' minDate details ', minDate + ' hourEnding', hourEndString)
                    minDate.setDate(minDate.getDate())
                    minDate.setHours(hourStart)
                    minDate.setMinutes(Number(hourStartString.substring(2,4)))
                    this.minDate = minDate
                    this.order.schedule.datetime = this.minDate
                    console.log('Min Date is out of operation hour and change to the nearest ', hourStart + ' mindate Hours>> ', minDate.getHours())
                  } else {
                    console.log('timeTodayLength',timeTodayLength)
                    console.log('minDate if less than hourStart',minDate,' hourstart',hourStart, ' hourstartstring',hourStartString)
                    if (hourStart < minDate.getHours()){
                      continue;
                    } else {
                      minDate.setDate(minDate.getDate())
                      minDate.setHours(hourStart)
                      minDate.setMinutes(Number(hourStartString.substring(2,4)))
                      console.log('Mindate after change',minDate)
                      this.minDate = minDate
                      this.order.schedule.datetime = this.minDate
                      break;
                    }
                  }
                }
              }
            }
          }
        }
        console.log('minDate after business hours validation', this.minDate)

        let holiday = this.holiday.data
        let dateMin = new Date(this.minDate)
        for (let i in holiday){
          for (let j in holiday[i]){
            let dateHoliday = new Date(j);
            if (dateMin.getFullYear() == dateHoliday.getFullYear()){
              if (dateMin.getMonth() == dateHoliday.getMonth()){
                if (dateMin.getDate() == dateHoliday.getDate()){
                console.log('dateMin data ', dateMin + ' dateHoliday data ', dateHoliday)
                  for (let k in holiday[i][j]){
                    let hourStartString = holiday[i][j][k]['start'].toString().padStart(4,"0")
                    let hourEndString = holiday[i][j][k]['end'].toString().padStart(4,"0")
                    let hourStart = Number(hourStartString.substring(0,2))
                    let hourEnd = Number(hourEndString.substring(0,2))
                    console.log('Hour start holiday ', hourStartString + ' hour end holiday ', hourEndString)
                    if (dateMin.getHours() > hourStart && dateMin.getHours() < hourEnd){
                      this.minDate.setHours(hourEnd)
                      this.minDate.setMinutes(Number(hourEndString.substring(2,4)) + 10)
                      this.order.schedule.datetime = this.minDate
                      console.log('minDate after holiday validation', this.minDate);
                      this.checkBusinessHour(this.minDate)
                    } else if (dateMin.getHours() == hourStart){
                      if (dateMin.getMinutes() >= Number(hourStartString.substring(2,4))){
                        this.minDate.setHours(hourEnd)
                        this.minDate.setMinutes(Number(hourEndString.substring(2,4)) + 10)
                        this.order.schedule.datetime = this.minDate
                        console.log('minDate after holiday validation', this.minDate);
                        this.checkBusinessHour(this.minDate)
                      }
                    } else if (dateMin.getHours() == hourEnd){
                      if (dateMin.getMinutes() <= Number(hourEndString.substring(2,4))){
                        this.minDate.setMinutes(Number(hourEndString.substring(2,4)) + 10)
                        this.order.schedule.datetime = this.minDate
                        console.log('minDate after holiday validation', this.minDate);
                        this.checkBusinessHour(this.minDate)
                      }
                    }
                  }
                }
              }
            }
          }
        }
        console.log('No date time change ', this.minDate)
        return this.order.schedule.datetime = this.minDate
    },
    getDaysNumber(stringKey) {
      if (stringKey == 'SUNDAY'){
        return 0;
      } else if (stringKey == 'MONDAY'){
        return 1;
      } else if (stringKey == 'TUESDAY'){
        return 2;
      } else if (stringKey == 'WEDNESDAY'){
        return 3;
      } else if (stringKey == 'THURSDAY'){
        return 4;
      } else if (stringKey == 'FRIDAY'){
        return 5;
      } else if (stringKey == 'SATURDAY'){
        return 6;
      }
    },
    getDays(stringKey) {
      if (stringKey == 0){
        return 'SUNDAY';
      } else if (stringKey == 1){
        return 'MONDAY';
      } else if (stringKey == 2){
        return 'TUESDAY';
      } else if (stringKey == 3){
        return 'WEDNESDAY';
      } else if (stringKey == 4){
        return 'THURSDAY';
      } else if (stringKey == 5){
        return 'FRIDAY';
      } else if (stringKey == 6){
        return 'SATURDAY';
      }
    },
    setMaxDate() {
      let currDT = (new Date()).getTime();
      let maxDate = currDT + (6 * 3600 * 1000);
      console.log('maxDate>>>', new Date(maxDate));
      this.maxDate = new Date(maxDate);
    },
    confirmFn(schedule_datetime) {
      this.order.schedule.datetime = schedule_datetime;
      this.resolveDateTime();

      const time1 = (new Date()).getTime(), time2 = this.order.schedule.datetime.getTime(), ftime = (time2 - time1) / 1000 / 60;

      if(this.order.schedule.type) {
        if (!(time2 > time1 && ftime >= 30)) {
          this.$toast('Datetime must be 30 minutes in advanced')
        } else {
          this.resolveDateTime();
          this.quotation();
        }
      }

      this.showDishDatetime = false
    },
    cancelFn() {
      this.showDishDatetime = false
    },
    resolveDateTime() {
      let selectedDateTime = this.order.schedule.datetime;
      
      if(this.order.schedule.type && selectedDateTime.getMinutes()%10 > 0) {
        this.order.schedule.datetime.setMinutes(selectedDateTime.getMinutes() + (10-(selectedDateTime.getMinutes()%10)));
        selectedDateTime = this.order.schedule.datetime;
      }

      selectedDateTime.setSeconds(0);
      this.order.schedule.datetime = selectedDateTime;
      this.dish_datetime = moment(this.order.schedule.datetime, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm');
      console.log('dish_datetime>>>', this.dish_datetime);
    },
    get_data() {
      this.getApiData()
    },
    getApiData() {
      //处理返回来的数据
      const todo = cartindex => {
        const tempcart = cartindex && cartindex.cart.map(item => {
          let itemFinalPrice = item.marketprice
          if (item.isspecial) {
            if (parseInt(item.isspecial) == 2) {
              itemFinalPrice = item.price
            }
          }
          const tempItem = {
            detail: {
              thumb: item.thumb,
              title: item.title,
            },
            name: item.title,
            options: [item.optionname],
            qty: item.total,
            price: itemFinalPrice
          }
          return tempItem
        })

        this.goodsList = tempcart
        this.table = {
          title: cartindex.table.title,
          promo: cartindex.store.promo || '',
          tel: cartindex.store.tel,
          table: cartindex.table,
          tablezones: cartindex.tablezones,
        }
        this.cart.summmary = cartindex.summmary
        this.cartTotal = cartindex.cartTotal || '0.00'
      }
      const takeawayUser = () => {
        //如果已登录并且是 takeaway 时，自动填写名称和电话
        if (this.sso.is_login && this.sso.user_info && this.sso.user_info.firstName) {
          if (this.isTakeaway || this.isDelivery) {
            this.isLogin = this.sso.is_login || false
            this.receiver_name = this.sso.user_info.firstName + ' ' + this.sso.user_info.lastName
            this.receiver_phone = this.sso.user_info.mobileNumber || ''
          }
        }
      }
      if (this.isDevEnv()) {
        const cartindex = mockDemo.cartPage.data
        this.isTakeaway = cartindex.isTakeaway || false
        cartindex && todo && todo(cartindex)
        setTimeout(() => {
          this.isRequest = true
        }, 1000)
      } else {
        const actname = 'wapmenu'
        const queryParams = this.getUrlParams({ 'h5api': 'on', 'do': 'wapmenu', 'orderid': 0 })
        cartPage('/app/index.php', queryParams).then(res => {
          const cartindex = res.data
          if (cartindex.wapmenu_type && cartindex.wapmenu_type == 'new_page') {
            window.location.href = cartindex.forward_url
          } else {
            this.store.isEpointEnabled = cartindex.store.pos_status && cartindex.store.pos_name==='epoint'? true:false;
            this.isTakeaway = cartindex.isTakeaway || false
            this.isDelivery = cartindex.isDelivery || false
            this.isSchedule = cartindex.isSchedule || false
            if (cartindex.deliveryOption != null){
                this.deliveryOption = cartindex.deliveryOption
            }
            this.scheduleType = cartindex.scheduleType || false
            this.businessHours = cartindex.businessHours || {}
            this.holiday = cartindex.holiday || {}
            this.sso = cartindex.sso || {}
            if (this.isDelivery) {
              this.store.id = cartindex.store.id;
              this.store.title = cartindex.store.title;
              this.store.logo = cartindex.store.logo;
              this.store.tel = cartindex.store.tel;
              this.store.readyInMinute = cartindex.store.food_preparation_time;
              this.store.location.address = cartindex.store.address;
              this.store.store_delivery_service_type = cartindex.store.store_delivery_service_type;
              this.store.store_delivery_service_package = cartindex.store.store_delivery_service_package;
              this.store.is_rest = cartindex.store.is_rest;
              this.store.is_show = cartindex.store.is_show;
              this.store.location.lat = cartindex.store.lat;
              this.store.location.lng = cartindex.store.lng;
              this.store.isEmailRequired = (cartindex.store.visiable_email && cartindex.store.visiable_email_delivery) || false

              this.order.etaInMinute = this.store.readyInMinute*60;

              this.saveCurrentStoreInfo(this.store);
              const current_delivery_address = cartindex.current_delivery_address || false;
              if (current_delivery_address) {
                this.isQuotation = current_delivery_address.quotation ? true : false
                this.receiver_name = current_delivery_address.nickname
                this.receiver_phone = current_delivery_address.mobile
                this.saveCurrentAddress(current_delivery_address) //如何用户已选择了地址，返回的时候，要把已选择地址覆盖vuex中的地址
              }
            }
            if (cartindex.cart && cartindex.cart.length) {
              cartindex && todo && todo(cartindex)
              setTimeout(() => {
                this.isRequest = true
              }, 100)
            } else {
              // console.log('购物车为空，返回首页');
              queryParams["do"] = 'waplist'
              const url = { path: '/', query: queryParams }
              this.$router.push(url)
            }
          }

          if (this.scheduleType){
            this.order.schedule.type = true
          } else {
            this.order.schedule.type = false
          }

          if (this.deliveryOption.choosedService == 'STANDARD_24'){
            this.isSchedule = false;
            this.order.schedule.type = false;
          }
          this.isScheduleEnabled();
          
        }).catch((error) => {
          console.log('====>error', error)
        })
      }
    },
    async quotation() {
      const queryParams = { i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'get_delivery_quotation' }
      const suffixQuery = Object.keys(queryParams).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])).join("&")
      getDeliveryQuotation('/app/index.php?' + suffixQuery, {serviceType:this.deliveryOption, store: this.delivery_current_storeinfo, dish_datetime: this.order.schedule.datetime, schedule_type: this.order.schedule.type }).then(res => {
        this.isRequest = true
        if (res.status == false) {
          this.$toast(res.msg)
        } else {
          if(res.data) {
            let delivery = this.cart.summmary.find(i => i.type==='delivery');
            if(delivery && res.data.totalFee) {
              delivery.text = res.data.totalFee.toFixed(2);
            }

            let total = 0;
            this.cart.summmary.forEach(function(summary) {
              let totalSummary = summary.text;
              if (summary.text.includes(',')){
                  totalSummary = summary.text.replace(',','');
              }
              total = total + +totalSummary;
            })

            this.cartTotal = total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            this.order.etaInMinute = res.data.etaInMinute + (this.store.readyInMinute*60);
          }
        }
      }).catch(error => {
        this.isRequest = true
        console.log('.............quotation.......error', error);
      })
    },
    cleanCoupon() {
      this.coupon_code = ''
      this.cart.summmary.promo.text = 0
    },
    applyCoupon() {
      this.isCoupon = this.coupon_code == 'save10'
      this.cart.summmary.promo.text = 0
      if (this.isCoupon)
        this.cart.summmary.promo.text = -10

      this.popupCoupon = false
    },
    placeorder() {
      if(!this.order.schedule.type) {
        this.order.schedule.datetime = new Date();
        this.resolveDateTime();
      }
      
      const getRouteQuery = () => {
      let tempParams = this.$route.query
      if (tempParams.h5api == undefined) {
        tempParams["h5api"] = 'on'
      }
      tempParams["do"] = 'validateBusinessAndHoliday' 
      return tempParams
      }
      const updateOption = () => {
      const queryParams = Object.assign(getRouteQuery(), {optype: 'businessAndHoliday', schedule_type: this.order.schedule.type});
      validateBusinessAndHoliday("/app/index.php", queryParams)
            .then(res => {
              this.indexPage = res.data
              this.storeInfo = this.indexPage.store
              this.businessHours = this.indexPage.businessHours
              this.holiday = this.indexPage.holiday
              let storeAvailable = false;
              let orderTime = new Date(this.order.schedule.datetime)
              let hourOrder = orderTime.getHours().toString().padStart(2,'0') + orderTime.getMinutes().toString().padStart(2,'0')
              let dateOrder = orderTime.toISOString().slice(0,10)
              let dayOrder = this.getDays(orderTime.getDay())
              console.log('Day order scheduled ',dayOrder)

              for (let i in this.businessHours.data){
                for (let j in this.businessHours.data[i]){
                  for (let k in this.businessHours.data[i][j]){
                    if (dayOrder == j){
                      let hourStartBusinessString = this.businessHours.data[i][j][k]['start'].toString().padStart(4,'0')
                      let hourEndBusinessString = this.businessHours.data[i][j][k]['end'].toString().padStart(4,'0')
                      let hourStartBusiness = Number(hourStartBusinessString)
                      let hourEndBusiness = Number(hourEndBusinessString)
                      if (hourOrder >= hourStartBusiness && hourOrder <= hourEndBusiness){
                        storeAvailable = true;
                        console.log('In operation hours')
                        break;
                      } else {
                        storeAvailable = false;
                        console.log('Not in operation hours')
                      }
                    }
                  }
                }
              }

              for (let i in this.holiday.data){
                for (let j in this.holiday.data[i]){
                  for (let k in this.holiday.data[i][j]){
                    if (j == dateOrder){
                      let hourStartHolidayString = this.holiday.data[i][j][k]['start'].toString().padStart(4,'0')
                      let hourEndHolidayString = this.holiday.data[i][j][k]['end'].toString().padStart(4,'0')
                      let hourStartHoliday = Number(hourStartHolidayString)
                      let hourEndHoliday = Number(hourEndHolidayString)
                      console.log('Hour Holiday to validate ', hourStartHoliday + ' and ',hourEndHoliday)
                      if (hourOrder >= hourStartHoliday && hourOrder <= hourEndHoliday){
                        storeAvailable = false;
                      }
                    }
                  }
                }
              }
              console.log('Store is available after validation ',storeAvailable)

              if (!this.isSubmit) {
                if (!this.isTermsAccepted) {
                  this.$toast('Please agree to FastOrder.my terms & conditions and privacy policy before placing the order.')
                } else if (!this.isQuotation) {
                  this.$toast('Oops, we unable to proceed with your address. Please check again your address and try again later.')
                } else if (this.deliveryOption.delivery_service == 'delyva' && this.deliveryOption.choosedService == null) {
                  this.$toast('Cannot accept order without any choosen delivery. Please choose the delivery service!')
                } else if (this.order.schedule.type && this.order.schedule.datetime == '') {
                  this.$toast('Oops, something wrong with your date & time for your advanced order.')
                } else if (this.storeInfo.is_24_hours_operation == 1 && this.order.schedule.type && storeAvailable == false) {
                  this.$toast('Merchant is not operating during the scheduled datetime, please try again another time!')
                } else if (this.storeInfo.is_24_hours_operation == 1 && this.order.schedule.type == false && this.deliveryOption.choosedService != 'STANDARD_24' && this.storeInfo.is_rest != 1 || this.storeInfo.is_show != 1) {
                  this.$toast("Merchant is not operating, please try again later!")
                } else if (this.storeInfo.is_24_hours_operation == 0 && this.order.schedule.type && storeAvailable == false) {
                    this.$toast("Merchant is not operating during the scheduled datetime, please try again another time!")
                } else if (this.storeInfo.is_24_hours_operation == 0 && this.storeInfo.is_rest != 1 || this.storeInfo.is_show != 1) {
                    this.$toast("Merchant is not operating, please try again later!")
                } else {
                  if (this.visiable_email && this.email == '') {
                    this.$toast('The email is required!')
                  } else {
                    this.isSubmit = true;
                    this.isRequest = true;
                    
                    this.order.user.name= this.receiver_name;
                    this.order.user.contact= this.receiver_phone;
                    this.order.user.email= this.email;
                    this.order.address.name= this.delivery_current_address.name;
                    this.order.address.address1= this.delivery_current_address.address;
                    this.order.address.address2= this.delivery_current_address.address2;
                    this.order.address.address3= this.delivery_current_address.address3;
                    this.order.address.city= this.delivery_current_address.city;
                    this.order.address.state= this.delivery_current_address.state;
                    this.order.address.country= this.delivery_current_address.country;
                    this.order.address.zip= this.delivery_current_address.zipcode;
                    this.order.address.lat= this.delivery_current_address.lat;
                    this.order.address.lng= this.delivery_current_address.lng;

                    console.log('this.order>>>', this.order);
                  }
                }
              }
            })
            .catch(error => {
              // console.log('添加到购物车.error', error);
            });
      };
      updateOption();
    },
    confirmOrder() {
      let loader = this.$loading.show({
        container: null
      });

      const queryParams = this.getUrlParams({ 'h5api': 'on', 'do': 'add_deliveryorder' })
      const postData = {
        type: 'add',
        total: this.cartTotal,
        ordertype: 1,
        address: 'undefined',
        receiver_name: this.order.user.name,
        receiver_phone: this.order.user.contact,
        email: this.order.user.email,
        isnew_phone: 0,
        is_tc: this.isTermsAccepted,
        tables: queryParams.tablesid || 0,
        order_id: 0,
        couponid: 0,
        meal_time: '',
        dispatcharea: '',
        schedule_type: this.order.schedule.type,
        dish_datetime: this.order.schedule.datetime,
        membership_id: this.membership_id,
        receiver_addr1: this.order.address.address1 || '',
        receiver_addr2: this.order.address.address2 || '',
        receiver_addr3: this.order.address.address3 || '',
        counts: 0,
        remark: this.order.remark
      }
      if (this.deliveryOption.delivery_service == 'teleport' || this.deliveryOption.delivery_service == 'lalamove' || this.deliveryOption.delivery_service == 'delyva'){
        postData.delivery_service_feature = this.deliveryOption.choosedService;
      }
      if (this.deliveryOption.delivery_service == 'delyva'){
        postData.delivery_service_name = this.deliveryOption.descService;
      }

      const strApiName = '/app/index.php?' + this.parseParams(queryParams)
      addToOrder(strApiName, postData).then(res => {
        if (res.type == 'ajax' || res.type == 'json') {
          const strUrl = (res.redirect != '' && res.message == '') ? res.redirect : res.data.orderDetailUrl
          if (res.status && parseInt(res.code) == 200) {
            window.location.href = strUrl
          } else {
            this.$toast(res.msg)
          }
          this.isSubmit = false
        } else {
          this.$toast(res.message || 'request network error1')
          this.isSubmit = false
          this.isRequest = true
        }
      }).catch((error) => {
        console.log('Caught error during addToOrder >>> ', error);
        this.isSubmit = false
        this.isRequest = true
        this.$toast({
          message: 'request network error',
          onClose: () => {
            // queryParams.do = 'waplist'
            // const url = { path: '/', query: queryParams }
            // this.$router.push(url)
          }
        })
      }).finally(()=>{ 
        loader.hide();
      });
    },
    cancelOrder() {
      this.isSubmit=false;
      console.log('cancel submit...>>>', this.isSubmit);
    },
    parseParams(data) {
      try {
        var tempArr = [];
        for (var i in data) {
          var key = encodeURIComponent(i);
          var value = encodeURIComponent(data[i]);
          tempArr.push(key + '=' + value);
        }
        var urlParamsStr = tempArr.join('&');
        return urlParamsStr;
      } catch (err) {
        return '';
      }
    },
    evtLogout(option) {
      this.isLogin = option.isLogin
      this.receiver_name = ''
      this.receiver_phone = ''
    },
    funTC(strLink) {
      window.open(strLink, '_blank')
    },
    userAddressList() {
      if (this.user_islogin) {
        this.receiver_phone = this.user_detail.mobileNumber
      }
      if (this.user_islogin) {
        this.$router.push({ path: '/user/addressList' })
      } else {
        const url = {
          path: "/user/addressDetail",
          query: { "address_id": 0 }
        };
        this.$router.push(url);
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');

.cart-index {
  text-align: left;
  margin: 36px 0 40px 0;
  .main {
    background-color: @fff;
    color: #323233;
    .order-store-name {
      padding: 12px 5px 0px 5px;
      font-size: 18px;
      .store-logo {
        margin-right: 10px;
        img {
          width: 40px;
          height: 40px;
          object-fit: fill;
          border-radius: 50%;
        }
      }
    }

    //顶部内容
    .tables-room {
      padding: 5px;
      font-size: @size14;
      .row {
        margin: 5px 0;
        .label {
          flex-basis: 120px;
        }
        .colons {
          font-weight: 700;
          padding: 0 3px;
        }
        .text {
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
    //菜单列表
    .product-list {
      .item-name {
        flex: 1;
      }
      .item-qty {
        flex-basis: 30px;
        text-align: center;
      }
      .item-price {
        flex-basis: 60px;
        text-align: right;
      }
      .list-header {
        padding: 5px;
      }
      .list-items {
        margin: 5px 0;
        padding: 5px;
        font-size: @size14;
        .item-image {
          flex-basis: 100px;
          margin: 0 8px 0 0;
          img {
            width: 100%;
            max-width: 100px;
            max-height: 75px;
            border-radius: 5px;
          }
        }
      }
      .line-top {
        border-top: 1px solid rgba(0, 0, 0, 0.06);
      }
    }

    .lalmove-dropdown {
      border: 0px;
      background-color: #ffffff;
      font-size: 12px;
      border-radius: 3px;
      border: 1px solid #eeeeee;
      padding: 2px 5px;
      width: 50%;
      .lalmove-dropdown-option {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
      }
    }
    .custom-form {
      margin: 0px 0 106px 0;
      border-top: 1px solid #eee;
    }
    .user-nav-name {
      padding: 4px 12px;
      .schedule-item {
        font-size: 12px;
      }
      .user-nav-name-label {
        padding: 0;
        margin: 5px 0 0 0;
        font-size: 14px;
        flex-basis: 120px;
      }
      .user-nav-name-value {
        text-align: right;
        font-size: 12px;
      }
      .select-address {
        margin-left: 10px;
        text-align: right;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.5);
        .delivery-address {
          color: black;
        }
        .delivery-contact {
          color: #ff3838;
        }
      }
      .inputfocus {
        padding: 2px 5px;
        border: 0px;
      }
      .inputfocus:focus {
        box-shadow: 0 0px 5px 0px hsla(191, 84%, 64%, 0.35),
          -10px 10px 10px 10px hsla(0, 0%, 100%, 0.5);
      }
      .contact-phone {
        border: 0px;
        text-align: right;
        font-size: 12px;
        > input.vti__input {
          text-align: right;
        }
      }
    }
    .checkbox-mobile-label {
      padding: 1px 0;
      font-size: 13px;
      .linkcolor {
        color: #0643e9;
      }
    }
    .import_text1 {
      font-weight: bold;
      display: contents;
      font-size: 12px;
    }
    .import_text2 {
      font-weight: bold;
      display: contents;
      font-size: 12px;
    }
  }
  .footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;

    //概览内容
    .summary {
      background-color: #f0f0f0;
      padding: 10px 8px;
      font-size: @size14;
      color: #000000;
      .colons {
        font-weight: 700;
        padding: 0 3px;
      }
      .currency {
        padding: 0 3px;
      }
      .text {
        flex-basis: 50px;
        text-align: right;
        font-size: @size14;
      }
    }

    .place-order {
      background-color: #4d4d4d !important;
      color: #ffffff;
      .rm-price {
        padding-left: 10px;
      }
      .btn-order {
        padding: 10px 8px;
        background-color: #ee0a24 !important;
        display: flex;
      }
      .colons {
        border-left: 1px solid rgba(255, 255, 255, 0.8);
        flex-basis: 1px;
        height: 10px;
      }
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #ffffff;
    font-size: 10px;
  }

  .block {
    width: 90%;
    // height: 120px;
    text-align: center;
    background-color: #fff;
    border-radius: 5px;
    padding: 10px;
    font-size: 14px;
    color: #323233;
    .foce-phone-number {
      font-weight: bold;
      font-size: 16px;
      padding: 20px 0;
    }
    .btn-action {
      font-weight: bold;
      font-size: 14px;
      margin: 20px 0 0 0;
      .btn-confirm {
        color: #ee0a24;
      }
      .btn-cancel {
        color: rgba(0, 0, 0, 0.596);
      }
    }
  }

  .hideVisibility {
    z-index: -1;
  }

  .showVisibility {
    z-index: 1;
  }
}
</style>